module.exports = __webpack_public_path__ + "static/latish.80e35f19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/latish.jpg
// module id = 600
// module chunks = 114276838955818